import ChargeCenterRouteButtons from '@/app/routes/ChargeCenter/ChargeCenterRouteButtons';
import GridConnectionsMonitor from '@/app/routes/ChargeCenter/GridConnectionsMonitor';
import { useAppSelector } from '@/features';
import GridConnectionsMonitorSkeleton from '@/modules/charge-center/skeleton-components/grid-connections-monitor-skeleton';
import { assetsIsFetching } from 'features/assets/selectors';

const ChargeCenterMonitor = () => {
  const assetsLoading = useAppSelector(assetsIsFetching);
  return assetsLoading === 'idle' || assetsLoading === 'pending' ? (
    <GridConnectionsMonitorSkeleton />
  ) : (
    <>
      <ChargeCenterRouteButtons />
      <GridConnectionsMonitor />
    </>
  );
};

export default ChargeCenterMonitor;
